<template>
  <div id="observation-dl">
    <div class="row">
      <div class="col-md-8 col-md-offset-0 col-sm-offset-2 col-sm-8">
        <div class="panel panel-observa4">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>OBSERVA4</strong></h2>
          </div>
          <div class="panel-body">
            <ul>
              <span v-for="(b, k) in files.observa4"
                   :key="k">
                <div class="col-md-6">
                  <link-block :file="b.file"
                              :link="b.link"
                              :description="b.description"
                              :title="b.title"
                              class="fb-observa4"
                              :text="b.text"
                              :icon="b.icon">
                  </link-block>
                </div>
                <div v-if="!((k + 1) % 2)" class="clearfix"></div>
              </span>
            </ul>
          </div>
          <!--div class="panel-footer text-center">
            <a :href="require(`@/assets/${files.zips.observa4.file}`)"
               :download="files.zips.observa4.description">
              Tout télécharger
            </a>
          </div-->
        </div>
      </div>
      <div class="col-md-4 col-md-offset-0 col-sm-offset-2 col-sm-8">
        <div class="panel panel-spy4">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>SPY4</strong></h2>
          </div>
          <div class="panel-body">
            <ul>
              <link-block v-for="(b, k) in files.spy4"
                          :key="k"
                          :file="b.file"
                          :link="b.link"
                          :description="b.description"
                          :title="b.title"
                          class="fb-spy4"
                          :text="b.text"
                          :icon="b.icon">
              </link-block>
            </ul>
          </div>
        </div>

        <div class="panel panel-reaExplaur">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>RÉA expl AUR</strong></h2>
          </div>
          <div class="panel-body">
            <ul>
              <link-block v-for="(b, k) in files.reaExplaur"
                          :key="k"
                          :file="b.file"
                          :link="b.link"
                          :description="b.description"
                          :title="b.title"
                          class="fb-reaExplaur"
                          :text="b.text"
                          :icon="b.icon">
              </link-block>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-md-8 col-md-offset-0 col-sm-offset-2 col-sm-8">
        <div class="panel panel-gray">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>Annexes</strong></h2>
          </div>
          <div class="panel-body">
            <ul>
              <div v-for="(b, k) in files.annexes"
                    :key="k">
                  <div v-if="b.multiRef" class="col-xs-12">
                    <link-block :link="b.link"
                                :description="b.description"
                                :title="b.title"
                                class="fb-gray"
                                :text="b.text"
                                :icon="b.icon">
                    </link-block>
                  </div>
              </div>
            </ul>
          </div>
          <!--div class="panel-footer text-center"
                v-if="files.zips.annexes.file">
            <a :href="require(`@/assets/${files.zips.annexes.file}`)"
                :download="files.zips.annexes.description">
              Tout télécharger
            </a>
          </div-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import linkBlock from '@/components/linkBlock'
import sc from '@/sc/presentation'

export default {
  name: 'observation-dl',

  computed: {
    files: function () {
      return sc.files
    }
  },

  components: {
    'link-block': linkBlock
  }
}
</script>

<style scoped lang="less">
ul {
    padding-left: 1rem;
    padding-right: 1rem;
}
h2.panel-title {
  font-size: 180%;
}
</style>
